import { createContext, useContext } from 'react';

import type MaterialCostSource from 'ab-enums/materialCostSource.enum';

export interface IMaterialCostSourceFilterContext {
	filters: Record<MaterialCostSource, boolean>;
	toggle: (source: MaterialCostSource) => void;
}

export const MaterialCostSourceFilterContext = createContext<Nullable<IMaterialCostSourceFilterContext>>(null);

export function useMaterialCostSourceFilterContext() {
	const context = useContext(MaterialCostSourceFilterContext);
	if (!context) {
		throw new Error('MaterialCostSourceFilterContext not initialized');
	}
	return context;
}
